import { PAGINATION_PAGES, PAGINATION_SHOW_MORE } from "@components/grid/Grid";
import { Button, Pagination } from "antd";
import React from "react";

const GridPagination = ({ paginationType, data, onPaginationChange, onPaginationSizeChange }) => {
    return (
        <>
            {(paginationType === PAGINATION_PAGES && data && data.pagination) && (
                <>
                    <Pagination
                        current={data.pagination.current_page}
                        pageSize={data.pagination.per_page}
                        total={data.pagination.total_items}
                        onChange={onPaginationChange ? onPaginationChange : () => { }}
                        showSizeChanger={false}
                        simple
                    />
                    <Pagination
                        className="only-size-changer"
                        current={data.pagination.current_page}
                        pageSize={data.pagination.per_page}
                        total={data.pagination.total_items}
                        showSizeChanger={true}
                        onShowSizeChange={onPaginationSizeChange ? onPaginationSizeChange : () => { }}
                    />
                </>
            )}
            {(paginationType === PAGINATION_SHOW_MORE && data && data.pagination) && (
                <Button className="loadMoreButton" onClick={() => {
                    if (onPaginationChange) {
                        onPaginationChange(data.pagination.next_page);
                    }
                }}>Load More</Button>
            )}
        </>
    );
};

export default GridPagination;